import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {QuestionnaireConstant} from "../../constants/questionnaire.enum";
import {Subject, takeUntil} from "rxjs";
import {
  surveySchedule
} from "../../../../shared/constants/validation.constants";
import {CommonService} from "../../../../shared/services/common.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {
  AddSurveySendScheduleDataRequest,
  EditSurveySendScheduleDataRequest,
  FetchSurveyDetailsByIdRequest
} from "../../core/questionnaires.actions";
import {FetchSurveyDetails} from "../../core/questionnaires.selectors";

@Component({
  selector: 'app-create-survey-schedule-screen',
  templateUrl: './create-survey-schedule-screen.component.html',
  styleUrls: ['./create-survey-schedule-screen.component.css']
})
export class CreateSurveyScheduleScreenComponent implements OnInit, OnDestroy {
  createSurveyScheduleForm: FormGroup = new FormGroup({
    title: new FormControl('', [
      Validators.required,
      Validators.min(
        surveySchedule.title.length.min
      ),
      Validators.pattern(surveySchedule.title.regex),
    ]),
    description: new FormControl('', [
      Validators.required,
      Validators.minLength(
        surveySchedule.description.length.min
      ),
      Validators.pattern(
        surveySchedule.description.regex
      ),
    ]),
  });

  mode: any = QuestionnaireConstant.add;
  errorMessageMap: any = {
    title: {
      required: 'This field is required.',
      pattern: 'This field should start with a character',
      minlength: 'Minimum 3 characters required',
    },
    description: {
      required: 'This field is required.',
      pattern: 'This field should start with a character',
      minlength: 'Minimum 3 characters required',
    },
  };
  errorMessages: any = {};

  private surveyId: string = '';
  surveyDetails:any
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private router: Router,
    private store: Store,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    if (this.router.url.includes(QuestionnaireConstant.edit)) {
      this.mode = QuestionnaireConstant.edit;
      this.route.paramMap.pipe(takeUntil(this.onDestroy))
        .subscribe((params: any) => {
          if (params?.params?.questionnaireId) {
            this.surveyId = params?.params?.questionnaireId
            this.store.dispatch(FetchSurveyDetailsByIdRequest({payload: {surveyId: params?.params?.questionnaireId}}));
          }
        });
      this.store.select(FetchSurveyDetails)
        .pipe(takeUntil(this.onDestroy)).subscribe(scheduleDetails => {
          this.surveyDetails=scheduleDetails
        this.createSurveyScheduleForm.patchValue({
          ...scheduleDetails
        })

      })
    }

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  validateFromDate(control: AbstractControl): ValidationErrors | null {
    const todaysDate = new Date()
    if (todaysDate > new Date(control.value)) {
      return {
        min: true
      }
    }
    return null
  }


  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.createSurveyScheduleForm, this.errorMessageMap, currentField))
    };
  }

  saveButtonClicked(navigate: boolean) {
    if (this.createSurveyScheduleForm.invalid) {
      this.checkForErrors();
      return
    }
    let scheduleFormData = {
      ...this.createSurveyScheduleForm.value,
      scheduleAccordingTo:null
    }

    if(this.surveyDetails?.scheduleAccordingTo){
      delete scheduleFormData.scheduleAccordingTo
    }

    if (this.mode === QuestionnaireConstant.edit) {
      this.store.dispatch(EditSurveySendScheduleDataRequest({
        payload: {
          scheduleFormData: scheduleFormData,
          mode: this.mode,
          surveyId: this.surveyId,
          navigate: navigate
        }
      }))
    } else {
      this.store.dispatch(AddSurveySendScheduleDataRequest({
        payload: {
          scheduleFormData: scheduleFormData, mode: this.mode, navigate: navigate
        }
      }))
    }
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
